import { Roles } from "@/models/user.model";
import { getUserFromStorage } from "@/utils/user-store.util";

export function guardAdmin(to: any, from: any, next: any) {
  if (getUserFromStorage()?.role == Roles.ADMINISTRATOR) {
    next();
  } else {
    next("/sign-in");
  }
}
